export const BillingCycle: any ={
    DAYS :"毎日",
    WEEKLY : "毎週",
    MONTHLY : "毎月",
    QUARTERLY : "四半期ごと",
    SEMIANNUALLY : "半年ごと",
    ANNUALLY : "毎年"
};